.wrapper {
  z-index: 1; /* for picker menu to appear above visualization */
  display: flex;
  padding: 0 0.5rem;
  font-size: 0.875rem;
}
